<h2 mat-dialog-title>Congratulations!</h2>
<mat-dialog-content class="mat-typography">
    Very nice! You won the game in {{playCount}} plays.
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Baralhar e recomeçar!</button>
</mat-dialog-actions>